<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Delete account</h3>
    <p>
      Are you sure you want to remove
      <strong>{{ account.login }}</strong>
      from {{ 'CORE.PRODUCT_NAME' | transloco }}?
    </p>
    <p>Here's what will happen:</p>
    <ul>
      <li>Deleting the connection to this account is irreversible.</li>
      <li>All {{ 'CORE.PRODUCT_NAME' | transloco }} components will be shut down for this account</li>
    </ul>
    <p>To confirm the deletion of this account, please type 'DELETE' in the box below:</p>
    <mat-form-field class="fw">
      <input matInput [(ngModel)]="inputEmail" />
    </mat-form-field>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <button [disabled]="deleting" type="submit" mat-flat-button class="button__secondary" (click)="cancelClicked()">
      Cancel
    </button>
    <button [disabled]="deleting || inputEmail !== 'DELETE'" type="submit" mat-flat-button (click)="okClicked()">
      <span>Delete</span>
      <mat-spinner *ngIf="deleting" class="button__spinner" [diameter]="30"></mat-spinner>
    </button>
  </div>
</div>
